import { getQueryClientContext } from './context';
export function useQueryClient(queryClient) {
    if (queryClient)
        return queryClient;
    return getQueryClientContext();
}
